import clsx from 'clsx';
import PropTypes from 'prop-types';
import { memo, useMemo } from 'react';

import { useApiContext } from '../../context/api-provider';
import { useConfig } from '../../context/config-provider';
import { Hyperlink } from '../hyperlink/hyperlink';
import { Image } from '../image/image';

import { customizations } from './brand-logo.customizations';
import { GTM_EVENTS } from './gtm';

import './brand-logo.scss';

export const VARIANTS = {
  SMALL: 'small',
  NORMAL: 'normal',
  RESPONSIVE: 'responsive',
};

function BrandLogoUI({ className, variant, width, height, ...props }) {
  const { site } = useConfig();
  const { apiConfig } = useApiContext();
  const config = customizations.useCustomizations();
  const logoSrc = variant === VARIANTS.NORMAL ? site.logo?.url : site.logoSmall?.url ?? site.logo?.url;
  const logoSources = useMemo(() => {
    if (variant === VARIANTS.RESPONSIVE && site.logoSmall?.url) {
      return [
        {
          media: '(min-width: 720px)',
          srcSet: site.logo?.url,
        },
        {
          media: '(max-width: 719px)',
          srcSet: site.logoSmall.url,
        },
      ];
    }

    return [];
  }, [site?.logo, site?.logoSmall, variant]);

  const logoUrl = config.isBrandLogoCasinoLink ? apiConfig.platformFrontendOrigin : '/';

  return (
    <Hyperlink
      className={clsx('sb-BrandLogo', `sb-BrandLogo-${variant}`, className)}
      trackingData={GTM_EVENTS.LOGO_CLICK}
      url={logoUrl}
      {...props}>
      <Image
        alt="logo"
        className="sb-BrandLogo-image"
        height={height}
        pictureClassName="sb-BrandLogo-picture"
        sources={logoSources}
        src={logoSrc}
        width={width}
      />
    </Hyperlink>
  );
}

BrandLogoUI.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.oneOf(Object.values(VARIANTS)),
  height: PropTypes.number,
  width: PropTypes.number,
};

BrandLogoUI.defaultProps = {
  className: undefined,
  variant: VARIANTS.RESPONSIVE,
  height: 40,
  width: 140,
};

export const BrandLogo = memo(BrandLogoUI);

BrandLogo.small = VARIANTS.SMALL;
BrandLogo.normal = VARIANTS.NORMAL;
